import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subscription, forkJoin } from 'rxjs';
import * as moment from 'moment';
import { confirm } from 'devextreme/ui/dialog';
import { GridAdditionComponent } from '../../../../../shared/components/grid-addition/grid-addition.component';
import { LanguageService } from '../../../../../shared/services/language.service';
import { AmsNotifierService } from '../../../../../shared/services/ams-notifier.service';
import { TimeService } from '../../../../time/_api/services/time.service';

@Component({
  selector: 'app-project-portal-list-detail-addition',
  templateUrl: './project-portal-list-detail-addition.component.html',
  styleUrls: ['./project-portal-list-detail-addition.component.css']
})
export class ProjectPortalListDetailAdditionComponent implements OnInit, AfterViewInit {

  @ViewChild(GridAdditionComponent, {static:false}) private additionGrid: GridAdditionComponent;

  @Input() showOnlyConfirmed: boolean = false;
  @Input() employeesNotQuit: any[];
  @Input() additionTypeDataSource: any[];
  @Input() showTransportColumn: boolean = false;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  @Output() editingStart = new EventEmitter<any>();
  @Output() cellPrepared = new EventEmitter<any>();
  @Output() showAdditionGrid = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  @Output() emitDataSourceAddition = new EventEmitter<any>();//emit event to parent to tell that datasource is changed

  private eventsSubscription: Subscription;
  @Input() dateChangedEvent: Observable<any>;

  gridColumns: any;
  gridRecords: any;
  setSelectedDateRangeIndexAddition: number = 0;//index in app-date-selector
  selectedDateRangeIndexAddition: number = 0;//index in app-date-selector
  initDateAddition: any;
  fromAddition: string;
  toAddition: string;
  projectIds: any[];

  // initDate: any;
  from: string;
  to: string;
  setSelectedDateRangeIndex: number = 0;//index in app-date-selector
  selectedDateRangeIndex: number = 0;//index in app-date-selector
  categoriesToApprove = [8,9];

  searchParameters = {
    EmployeeIds: [],
    FromDate: "",
    ToDate: "",
    CategoryStatusCombos: [],
    ProjectIds: [],
  }

  approvalFunction = 2;

  constructor(private languageService: LanguageService,
              private amsNotifierService: AmsNotifierService, private timeService: TimeService) { }

  ngOnInit() {
    this.eventsSubscription = this.dateChangedEvent.subscribe((dateInterval) => this.dateChanged(dateInterval));
    this.from = moment().format("DD.MM.YYYY");
    this.to = moment().format("DD.MM.YYYY");
  }

  ngAfterViewInit() {
    this.initAdditionGrid();
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  initSearchParameters() {

    //Eirik 10.12.19 task 154 - only show these combos of categories and statuses
    let categoryStatusCombos : any[] = [];
    //Eirik 16.08.21 task 854 - show unconfirmed additions.
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 1,
        StatusId: 2,
      });
      //Eirik 16.08.21 task 854 - show unconfirmed additions from transports.
      categoryStatusCombos.push( {
        CategoryId: 7,
        StatusId: 2,
      });
    }
    categoryStatusCombos.push( {
      CategoryId: 9,
      StatusId: 3,
    });
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 9,
        StatusId: 4,
        ShowEqualOrLargerThanStatus: true,
      });
    }
    categoryStatusCombos.push( {
      CategoryId: 8,
      StatusId: 3,
    });
    if (!this.showOnlyConfirmed) {
      categoryStatusCombos.push( {
        CategoryId: 8,
        StatusId: 4,
        ShowEqualOrLargerThanStatus: true,
      });
    }
    this.searchParameters.EmployeeIds = [];
    this.searchParameters.FromDate = this.from;
    this.searchParameters.ToDate = this.to;
    this.searchParameters.CategoryStatusCombos = categoryStatusCombos;
    this.searchParameters.ProjectIds = this.projectIds != null ? this.projectIds : [];
  }

  initAdditionGrid() {

    this.initSearchParameters();
    if (this.additionGrid) {
      this.additionGrid.initAdditionGrid(137);
    }
  }

  showDataField(dataFields: any, dataFieldName: string) {
    var visible = false;
    dataFields.forEach(name => {
      if (name === dataFieldName) {
        visible = true;
      }
    });
    return visible;
  }

  loadAddition() {

  }

  dateChangedAddition(dateInterval: any) {


  }



  initGridRecordsSearchParameters(iDateRangeIndex?: number, iSupervisorId?: number, initDate?: any) {

    if (iDateRangeIndex != null) {
      this.selectedDateRangeIndex = iDateRangeIndex;
      this.setSelectedDateRangeIndex = iDateRangeIndex;
    }
    // if (iSupervisorId != null) {
    //   this.selectedSupervisorId = iSupervisorId;
    // }
    // if (initDate) {

      this.from = moment().format("DD.MM.YYYY");
      this.to = moment().format("DD.MM.YYYY");
    // }
  }

  dateChanged(dateInterval: any) {
    this.checkUnsavedChanges().then((doSave:any)=>{
      if (doSave) {
        this.saveEditData();
      }
      else {
        this.cancelEditData();
      }

      if (dateInterval.FromDate !== null) {
        this.from = moment(dateInterval.FromDate).format("DD.MM.YYYY");
      }
      else {
        this.from = "01.01.0001";
      }
      this.to = moment(dateInterval.ToDate).format("DD.MM.YYYY");

      this.initAdditionGrid();
      this.additionGrid.loadGridRecords(this.searchParameters, false, false);
    });
  }

  saveEditData() {
    this.additionGrid.saveEditData();
  }

  cancelEditData() {
    this.additionGrid.cancelEditData();
  }

  selectAll() {
    this.additionGrid.dxgrid.instance.selectAll();
  }

  deselectAll() {
    this.additionGrid.dxgrid.instance.deselectAll();
  }

  checkUnsavedChanges(): Promise<boolean> {

    let hasEditData = this.additionGrid.hasEditData();
    return new Promise(resolve => {
    if (hasEditData) {
          var res = confirm(this.languageService.LNG("Label.Do.You.Want.To.Save.Changes.Before.Continuing",), this.languageService.LNG("Label.Unsaved.Changes"));
          res.then((yes: boolean) => {

            if (yes) {
              // this.timesalaryapprovalDetailTimeComponent.dataGrid.instance.saveEditData();
              resolve(true);
            }
            else {
              // this.timesalaryapprovalDetailTimeComponent.dataGrid.instance.cancelEditData();

              resolve(false);
            }
          });
      }
      else {
        resolve(false);
      }
    })
  }

  onRefreshGridAddition(refreshSearchCriterias: boolean = true) {
    this.onRefresh(null, refreshSearchCriterias);
  }

  onRefresh(showLoadIcon = true, refreshSearchCriterias: boolean = true) {
    this.initSearchParameters();
    if (this.additionGrid) {
      if (refreshSearchCriterias) {
        this.additionGrid.initAdditionGrid(137).then(isOk => {

          if (isOk) {
            this.additionGrid.loadGridRecords(this.searchParameters, refreshSearchCriterias, showLoadIcon);
          }
        });
      }
      else {
        this.additionGrid.loadGridRecords(this.searchParameters, refreshSearchCriterias, showLoadIcon);
      }
    }
  }

  //get from app-grid-addition and send to app-project-portal-detail
  onDataSourceEmittedAddition(dataSource) {
    this.emitDataSourceAddition.emit(dataSource);
  }

  getSelectedRows() {
    return this.additionGrid.dxgrid.instance.getSelectedRowKeys();
  }

  getSelectedRowsData() {
    return this.additionGrid.dxgrid.instance.getSelectedRowsData();
  }

  onApprove(preventApproveAll: boolean = false): Promise<boolean> {

    this.loading.emit(true);
    return new Promise(resolve => {

      let additionIds: number[] = [];
      let selectedRowsData = this.additionGrid.dxgrid.instance.getSelectedRowsData();
      if (selectedRowsData.length == 0 && !preventApproveAll) {
        this.additionGrid.dataSource.forEach(addition => {

          selectedRowsData.push(addition);
        });
      }

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
            additionIds.push(selectedRowsData[i].AdditionId);
        }

        if (additionIds.length > 0) {
          if (additionIds.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= additionIds.length) {
              let additionIdsSliced = additionIds.slice(startIndex, endIndex);
              if (additionIdsSliced.length === 0) {
                break;
              }

              let requestConfirm = this.timeService.approveAdditionByAdditionIds(additionIdsSliced, this.approvalFunction);
              arrayRequests.push(requestConfirm);
              startIndex = endIndex;
              endIndex = endIndex + 100 > additionIds.length ? additionIds.length : endIndex + 100;
              if (startIndex > additionIds.length) {
                break;
              }
            }
            forkJoin(arrayRequests).subscribe((results: any) => {

              this.loading.emit(false);
              let bAllOk = true;
              for(let result of results){
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                  bAllOk = false;
                }
              }
              if (bAllOk) {
                let okMessage = this.languageService.LNG("Label.Addition") + " " + this.languageService.LNG("Label.Is.Approved");
                this.amsNotifierService.success(okMessage);
                this.additionGrid.dxgrid.selectedRowKeys = [];
              }
              resolve(true);
            });
          }
          else {
            this.timeService.approveAdditionByAdditionIds(additionIds, this.approvalFunction).subscribe((result: any) => { // success path

              this.loading.emit(false);

              if (result.IsSuccess) {
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                this.additionGrid.dxgrid.selectedRowKeys = [];
                let okMessage = this.languageService.LNG("Label.Addition") + " " + this.languageService.LNG("Label.Is.Approved");
                this.amsNotifierService.success(okMessage);
                resolve(true);
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(false);
              }
            }, error => { // error path;
              this.loading.emit(false);
              resolve(false);
            });
          }
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Addition.Posts.To.Approve"));
          this.loading.emit(false);
          resolve(false);
        }
      }
      else {
        resolve(false);
      }
    })
  }

  onReset(statusId): Promise<boolean> {
    this.loading.emit(true);
    return new Promise(resolve => {
      let additionIds: number[] = [];
      let selectedRowsData = this.additionGrid.dxgrid.instance.getSelectedRowsData();

      if (selectedRowsData.length > 0) {
        for (let i = 0; i < selectedRowsData.length; i++) {
          additionIds.push(selectedRowsData[i].AdditionId);
        }

        if (additionIds.length > 0) {
          if (additionIds.length > 100) {
            let startIndex = 0;
            let endIndex = 100;
            let arrayRequests = [];
            while (endIndex <= additionIds.length) {
              let additionIdsSliced = additionIds.slice(startIndex, endIndex);
              if (additionIdsSliced.length === 0) {
                break;
              }

              let requestReset = this.timeService.resetAdditionByAdditionIds(additionIdsSliced, statusId, this.approvalFunction);
              arrayRequests.push(requestReset);
              startIndex = endIndex;
              endIndex = endIndex + 100 > additionIds.length ? additionIds.length : endIndex + 100;
              if (startIndex > additionIds.length) {
                break;
              }
            }
            forkJoin(arrayRequests).subscribe((results: any) => {

              this.loading.emit(false);
              let bAllOk = true;
              for(let result of results){
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                  bAllOk = false;
                }
              }
              if (bAllOk) {
                this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                this.additionGrid.dxgrid.selectedRowKeys = [];
              }
              resolve(true);
            });
          }
          else {
            this.timeService.resetAdditionByAdditionIds(additionIds, statusId, this.approvalFunction).subscribe((result: any) => { // success path

              this.loading.emit(false);

              if (result.IsSuccess) {
                if (result.Message !== null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                else {
                  this.additionGrid.dxgrid.selectedRowKeys = [];
                  this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
                }
                resolve(true);
              }
              else {
                this.amsNotifierService.error(result.ErrorMessage);
                resolve(false);
              }
            }, error => {
              this.loading.emit(false);
              resolve(false);
            });
          }
        }
        else {
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Posts.To.Reset"));
          this.loading.emit(false);
          resolve(false);
        }
      }
      else {
        resolve(false);
      }
    });
  }

  onEditingStart(e) {
    this.editingStart.emit(e);
  }

  onCellPrepared(e) {
    this.cellPrepared.emit(e);
  }

  onRowInserting(e) {

  }

  onRowUpdating(e) {

  }

  onRowRemoving(e) {

  }

  onCopySelectedRows(e) {

  }

  onDeleteSelectedRows(e) {

  }

  onLoadingDetail(loading: boolean) {

    this.loading.emit(loading);
  }

  onShowAdditionGrid(show: boolean) {

    this.showAdditionGrid.emit(show);
  }

  setSelectedRowByCarrierId(carrierId: number) {
    this.additionGrid.setSelectedRowByCarrierId(carrierId);
  }

  setDataSource(datasource: any) {
    this.additionGrid.dataSource = datasource;
  }


  @Input()
  set projectIdsDataSource(ids: any[]) {

    this.projectIds = ids;
  }

  @Input()
  set setShowTransportColumn(showColumn) {

    if (this.showTransportColumn !== showColumn) {
      this.showTransportColumn = showColumn;
      this.onRefresh();
    }
  }

}
